module.exports = __webpack_public_path__ + "img/flowersetting_02.7f1cb8b9.jpg";